import { Search } from '@/DTOS/ContractAdditionalAct/Search';
import request from '../../utils/request';

const ContractAdditionalActService = {
  search: (search: Search) => {
    return request('/contractAdditionalAct/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (/** @type {any} */ file: any) => {
    return request(
      '/contractAdditionalAct/upsert',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },
};

export default ContractAdditionalActService;
